import { render, staticRenderFns } from "./newcompany.vue?vue&type=template&id=357a4c17"
import script from "./newcompany.vue?vue&type=script&lang=js"
export * from "./newcompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports